import React from 'react';
import { Header } from '../components/Header';
import { PDFCatalogRenderer } from '../components/PDFCatalogRenderer';
import { Footer } from '../components/Footer';

export const Catalog = () => {
  return (
    <div className="page-wrapper">
      <Header />
      <main className="catalog-page">
        <section className="catalog-hero">
          <div className="catalog-container">
            <h1 className="catalog-title">Каталог продукції</h1>
            <div className="section-divider"></div>
            <p className="catalog-description">
              Ознайомтесь з повним асортиментом нашої продукції
            </p>
          </div>
        </section>
        
        <section className="catalog-content">
          <div className="catalog-container">
            <PDFCatalogRenderer />
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};
